<!-- 游戏嵌套 -->
<template>
    <div class="all" :class="{horSize: store.state.isHor}">
        <iframe ref="iframe" id="full_screen" class="full-screen" :style="[newStyle, horStyle]" :class="{hor: store.state.isHor}" :src="href" frameborder="0"
            height="100%" width="100%" scrolling="no" allow="fullscreen" :onerror="handleError">
        </iframe>
        <!-- <div class="close" @click="onClose">
            allow="fullscreen"
            <img src="@/assets/images/home/home_icon.png" />
        </div>
        <GameExitTip v-if="isShowExit" @onClose="onClose" @onExit="onExit"></GameExitTip> -->
    </div>
</template>

<script setup lang="ts">
import { freshBalance } from '@/handle/balanceHandle';
import { changeScene } from '@/handle/chcpHandle';
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from "vuex";

let props = defineProps({
    href: {
        type: String,
        default: ''
    },
    newStyle: {
        type: String,
        default: 'display: block !important;'
    },
});

const store = useStore();
const router = useRouter();
let load = 0;

let horStyle = ref<any>({});
watch(
    () => store.state.isHor,
    (newValue: boolean, oldValue: boolean) => {
        if (newValue == true) {
            let screenHeight = document.body.clientHeight; //669
            let screenWidth = document.body.clientWidth; // 390
            let rate = 1583 / 750;
            let rate2 = document.body.clientWidth / document.body.clientHeight;
            if (rate > rate2) {// 当屏幕尺寸比游戏尺寸要大以屏幕尺寸为主
                horStyle.value.width = `${screenHeight}px !important`;
                horStyle.value.height = `${screenHeight / rate}px !important`;
            } else {
                horStyle.value.width = `${window.screen.height}px !important`;
                horStyle.value.height = `${window.screen.height * rate}px !important`;
            }

            // horStyle.value.height = `${document.body.clientWidth}px !important`;
            // horStyle.value.width = `${document.body.clientHeight}px !important`;
        } else {
            horStyle.value = {};
        }
    }
)


let isShowExit: any = ref(false);

onMounted(() => {
    // window.addEventListener("message", function(e) {
    //     console.log("message:", e);
    //     console.log("e.origin:", e.origin);
    //     if (e.origin.indexOf(window.location.hostname) != -1) {
    //         onExit();
    //     }
    // });

    let iframe = document.getElementById("full_screen");
    if (iframe) {
        iframe.addEventListener('load', () => {
            console.log("load:", load);
            load ++;
            if(load == 2){
                onExit();
                store.state.isHor = false;
            }
            //window.postMessage("message go home", props.href);
        });
    }
    window.addEventListener("message", onEventBack);
});

function handleError() {
    onExit();
}

function onClose() {
    isShowExit.value = !isShowExit.value;
}

/**改变屏幕方向 竖屏 */
function reqChangeScene() {
    if (process.env.VUE_APP_ISAPP == "true") {
        changeScene("t");
    }
}

async function onExit() {
    load = 0;
    store.state.gameUrl = "";
    store.state.isShowMaskBg = true;
    reqChangeScene();
    setTimeout(() => {
        store.state.isShowMaskBg = false;
    }, 2000);
    try {
        freshBalance(true);
    } catch (error) {
        console.log(error);
    }
}

function onEventBack(e: any) {
    let data = e.data;
    if (data) {
        switch (data.msgType) {
            case "cc_game_web_shop"://打开充值
            goDeposit(data.msgData);
            break;
        }
    }
}

function goDeposit(data: any) {
    router.push('/deposit');
    onExit();
}

</script>
<style lang="less" scoped>
.all{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100000;
    left: 0;
    top: 0;
    background: #000000;
}

.full-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    z-index: 100000;
}

.close {
    position: fixed;
    z-index: 100000;
    top: 20rem;
    left: 20rem;
    width: 40rem;
    height: 40rem;
    >img {
        width: 100%;
        height: 100%;
    }
}

.hor{
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) rotate(90deg) !important;
    transform-origin: center center !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
}
</style>